import * as React from "react";
const SvgFiRrStarExclamation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-star-exclamation_svg__a)">
      <path
        fill="#062147"
        d="M12 18a1 1 0 0 1-1-1v-7a1 1 0 0 1 2 0v7a1 1 0 0 1-1 1m0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M23.833 8.53a3.175 3.175 0 0 0-3.067-2.226h-4.373l-1.324-4.047a3.18 3.18 0 0 0-3.073-2.24c-1.428 0-2.636.88-3.071 2.237L7.602 6.303H3.229c-1.425 0-2.63.876-3.07 2.229a3.18 3.18 0 0 0 1.163 3.602l3.566 2.606-1.355 4.272a3.18 3.18 0 0 0 1.184 3.609 3.22 3.22 0 0 0 1.89.62c.423 0 .885-.227 1.199-.417a1 1 0 0 0-1.036-1.711 2 2 0 0 1-.245.125 1.25 1.25 0 0 1-.64-.24 1.2 1.2 0 0 1-.448-1.377l1.574-4.962a1 1 0 0 0-.363-1.11l-4.146-3.03a1.19 1.19 0 0 1-.441-1.368 1.194 1.194 0 0 1 1.167-.847h5.098c.433 0 .816-.28.95-.69l1.55-4.744a1.194 1.194 0 0 1 1.17-.852c.551 0 1 .327 1.17.856l1.548 4.74a1 1 0 0 0 .951.689h5.099c.55 0 .997.323 1.166.846.17.52 0 1.047-.442 1.372l-4.145 3.029a1 1 0 0 0-.363 1.109l1.575 4.968a1.19 1.19 0 0 1-.448 1.372 1.24 1.24 0 0 1-.65.24 1.5 1.5 0 0 1-.192-.103 1 1 0 0 0-1.108 1.666c.247.165.733.44 1.227.44.677 0 1.331-.215 1.893-.622a3.175 3.175 0 0 0 1.183-3.603l-1.355-4.278 3.564-2.605a3.18 3.18 0 0 0 1.162-3.605z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-star-exclamation_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStarExclamation;
